import { Layout } from './layout';

Layout.displayName = 'Headline';

export { Layout as Headline };

export type { Props as HeadlineProps } from './types';
